import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { FinancialDocument } from 'src/features/financialDocuments/utils/types';
import { FinancialDocumentFormSchemaValues } from 'src/features/financialDocuments/utils/formSchema';

const RESOURCE = '/financial-documents/financial-document/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: FinancialDocumentFormSchemaValues): Promise<FinancialDocument> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateFinancialDocument };
